import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Tooltip } from "primereact/tooltip";
import { useAuthContext } from "../../../app/providers/contextIndex";

const CartSummary = ({
    resumenData = null,
    selectedUnits = 0,
    formattedSelectedTotal = "$0",
    selectedItems = [],
    selectedTotal = 0,
    formatResumenValue = (value, fallback) => fallback,
    onContinue = () => {},
    isContinuing = false,
    currencyFormatter = null,
    downloadingCotizacion = false,
    onDownloadCotizacion,
    onOpenSpecialistWhatsApp,
}) => {
    const navigate = useNavigate();
    const { appPerfil } = useAuthContext();
    const formatCurrency = (value) => {
        if (!value) return "$0";
        if (currencyFormatter && typeof value === 'number') {
            return currencyFormatter.format(value);
        }
        return String(value || "$0");
    };

    return (
        <Card className="getnet-summary-card">

            <h3><b>Resumen de compra</b></h3>
            
            {selectedItems.length > 0 ? (
                <>
                    <div className="getnet-summary-list">
                        {selectedItems.slice(0, 4).map((item) => (
                            <div key={`${item.code}-${item.name}`} className="getnet-summary-item">
                                <div>
                                    <strong>{item.name}</strong>
                                    <span>SKU: {item.code}</span>
                                </div>
                                <strong>{formatCurrency(Number(item.price || 0) * Number(item.quantity || 0))}</strong>
                            </div>
                        ))}
                    </div>

                    <div className="getnet-summary-totals">
                        <div>
                            <span>Productos</span>
                            <strong>{resumenData?.lineas ?? selectedUnits}</strong>
                        </div>
                        <div>
                            <span>Subtotal</span>
                            <strong>{formatResumenValue(resumenData?.subtotal, formattedSelectedTotal)}</strong>
                        </div>
                        <div>
                            <span>Neto</span>
                            <strong>{formatResumenValue(resumenData?.neto, formattedSelectedTotal)}</strong>
                        </div>
                        <div>
                            <span>IVA</span>
                            <strong>{formatResumenValue(resumenData?.iva, "$0")}</strong>
                        </div>
                        <div className="is-total">
                            <span className="font-bold text-base">Total</span>
                            <strong className="text-xl font-bold text-green-600">{formatResumenValue(resumenData?.total, formattedSelectedTotal)}</strong>
                        </div>
                    </div>
                </>
            ) : null}
            
            <div className="flex gap-2 mt-3 justify-content-center">
 
          
                <Button
                    icon="pi pi-plus"
                    label="Seguir comprando"
                    rounded
                    outlined
                    size="small"
                    disabled={downloadingCotizacion}
                    onClick={() => navigate("/catalogo")}
                />
           

                <Button
                    label={downloadingCotizacion ? "Validando..." : "Descargar cotización"}
                    icon={downloadingCotizacion ? "pi pi-spin pi-spinner" : "pi pi-download"}
                    outlined
                    rounded
                    onClick={onDownloadCotizacion}
                    disabled={!selectedItems.length || isContinuing || downloadingCotizacion}
                    size = "small"
                />
                <Button
                    label="Ver con Especialista"
                    icon="pi pi-whatsapp"
                    rounded
                    outlined
                    onClick={onOpenSpecialistWhatsApp}
                    disabled={downloadingCotizacion}
                    size = "small"
        
                />
      
                <Tooltip target=".btn-admin-disabled" />
                <Button
                    icon="pi pi-shopping-cart"
                    onClick={() => onContinue({ selectedItems, selectedTotal })}
                    disabled={!selectedItems.length || isContinuing || appPerfil === "Administrador" || downloadingCotizacion}
                    aria-disabled={!selectedItems.length || isContinuing || appPerfil === "Administrador" || downloadingCotizacion}
                    label={isContinuing ? "Procesando..." : "Ir a pagar"}
                    rounded
                    size="large"
                    severity="success"
                    className={appPerfil === "Administrador" ? "btn-admin-disabled" : ""}
                    data-pr-tooltip="Los administradores no pueden realizar compras"
                    data-pr-position="top"
                />
            </div>
                
        </Card>
    );
};

export default CartSummary;
